export default {
  'entityName': 'account',
  pagination: {
    'itemsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  filterStorage: {},
  'fields': [
    // {
    //   value: 'id',
    //   text: 'ID',
    //   visible:false,
    //   'type': 'text',
    //   'table': {
    //     'sortable': true,
    //     'filter': true
    //   },
    // },

    {
      value: 'email',
      text: 'Email',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
        'email'
        //issue email 200 caratteri
        ,
        'emaillen'
        //issue email 200 caratteri
      ]
    },
    {
      value: 'username',
      text: 'Username',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
      ]
    },
    {
      value: 'name',
      text: 'Name',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      render: item => `${item.name} ${item.surname}`,
      filter: (item, search) => [{ 'name': `%${search}%`},{'surname':`%${search}%`}],
      validators: ['required']
    },
    {
      value: 'surname',
      text: 'Surname',
      type: 'text',
      default: null,
      validators: [ 
        (field, value, item) => {
          if (item.role != 'Provider') {
            return value !== '' || 'Surname is required'
          }
          return true
        },
      ],
      readonly: (item) => item.role == 'Provider' || item.role == 'EMN Client',
    },

    {
      full:true,
      "value": "site_id",
      "text": "Site",
      "type": "autocomplete",
      title: item => { return item.name + ' [' + item.code + ']'},
      filter: (item, search) => [{ 'site.name': `%${search}%`}, {'site.code' : `%${search}%`}],
      deps:['role'],
      visible: (item) => { return item.role == 'Site' ? true : false},
      // render:  item => item.site.name
  },


  {
    full:true,
    "value": "lab_id",
    "text": "Lab",
    "type": "autocomplete",
    title:"name",
    deps:['role'],
    visible: (item) => { return item.role == 'Lab' ? true : false},
    // render:  item => item.lab.name
  },

    {
      value: 'role',
      text: 'Role',
      'type': 'combobox',
      loadRemote: false,
      'table': {
        'sortable': true,
        filter: true
      },
      'list': () => {
        let types = [
          'Administrator',
          'EMN Logistic',
          'Site',
          'Lab',
          'EMN Client',
           //issue 167
          'CLINICAL OPERATOR',
           //issue 167
        ]
        // if (state.user.role === 'Administrator') {
        //   types.unshift('Administrator')
        // }
        return types
      },
      render: (item) => {
        if(item.site_id) {
          return 'Site [' + item.site.code + ']'
        }

        if(item.lab_id) {
          return 'Lab [' + item.lab.code + ']'
        }

        return item.role
      },
      filter: (item, search) => [{ 'role': `${search}`},{'site.factor_label':`%${search}%`},{'lab.name':`%${search}%`}],
      tooltip: item => {
        if(item.site_id) {
          return item.site.factor_label
        }

        if(item.lab_id) {
          return item.lab.name
        }

        return null
      },
      'validators': [
        'required'
      ]
    },
    {
      value: 'status',
      text: 'Status',
      'type': 'list',
      'table': {
        'sortable': true,
        'filter': true
      },
      'list': [
        'Active',
        'Disabled',
        'Requested',
        'To Check',
      ],
      'validators': [
        'required'
      ]
    }
  ],
  actions: [
    { "value": "confirm", "text": "Confirm Account", "icon": "mdi-account-check", "color": "primary", 
      disable: (item) => {
         return item.status != 'Requested' && item.status != 'Disabled'
      }
    },
    {
      "value": "disableUser", "text": "Disable Account", "icon": "mdi-account-cancel", "color": "primary",
      disable: (item) => {
        return item.status != 'Active'
      }
    },
    { "value": "emulateUser", "text": "Emulate User", "icon": "mdi-head-sync-outline", "color": "primary", 
      disable: (item) => {
        return item.role == 'Administrator' || item.role == 'EMN Client' || item.role == 'Provider' 
      }
    },
    'upsert', 'audit_trail',
    { "value": "remove", "text": "Remove", "icon": "mdi-delete", "color": "primary", 
      "tooltip" : (item) => {
        const dataObj = new Date(item.insert_at)
        dataObj.setHours(dataObj.getHours() + 1)
        return "Deletable until " + dataObj.toLocaleTimeString()
      },
      "disable" : (item) => {  // si può eliminare solo se è stato inserito da meno di un'ora
        const dataObj = new Date(item.insert_at)
        const now = new Date();
        const differenceInMs = now - dataObj;
        const oneHourInMs = 60 * 60 * 1000;
        return Math.abs(differenceInMs) < oneHourInMs ? false : true
      } 
    },
  ]
}
